import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { LaunchDarklyFeatureFlags } from '@core/feature-flags';
import { GuardContext } from '../../contexts/GuardContext.js';
import { useAccessControl } from '../../hooks/useAccessControl.js';
import { useIsAuthorized } from '../../hooks/useIsAuthorized.js';
export var Guard = function Guard(param) {
    var canRender = param.canRender, canEdit = param.canEdit, _param_fallback = param.fallback, fallback = _param_fallback === void 0 ? null : _param_fallback, children = param.children;
    var parentGuardContextValue = useContext(GuardContext);
    var _useAccessControl = useAccessControl(), user = _useAccessControl.user, license = _useAccessControl.license;
    var isAuthorized = useIsAuthorized(canRender);
    if (isAuthorized) {
        var contextValue;
        if (canEdit === undefined && !parentGuardContextValue) {
            contextValue = {
                canEdit: true
            };
        } else if (canEdit === undefined) {
            contextValue = parentGuardContextValue;
        } else {
            var canEditResult = typeof canEdit === 'boolean' ? canEdit : canEdit({
                user: user,
                license: license,
                hasFeatureFlag: function hasFeatureFlag(flag, project) {
                    return LaunchDarklyFeatureFlags.isActive(flag, project);
                }
            });
            var currentGuardContextValue = typeof canEditResult === 'boolean' ? {
                canEdit: canEditResult
            } : canEditResult;
            contextValue = parentGuardContextValue ? _object_spread({}, parentGuardContextValue, currentGuardContextValue) : currentGuardContextValue;
        }
        return /*#__PURE__*/ _jsx(GuardContext.Provider, {
            value: contextValue,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: fallback
    });
};

//# sourceMappingURL=Guard.js.map